import React, { useState } from 'react';
import { Link, Element } from 'react-scroll';

const ContactSection = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setSubmitted(true);
    // Reset form after submission
    setTimeout(() => {
      setEmail('');
      setMessage('');
      setSubmitted(false);
    }, 3000);
  };

  // Main container styles
  const containerStyle = {
    backgroundColor: '#0a1438',
    color: 'white',
    padding: '80px 20px',
    borderRadius: '10px 10px 0 0',
    width: '100%',
    // maxWidth: '1200px',
    margin: '0 auto',
  };

  // Header styles
  const headerStyle = {
    textAlign: 'center',
    marginBottom: '40px',
  };

  const headingStyle = {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '15px',
  };

  const subheadingStyle = {
    fontSize: '18px',
    color: '#aab7d4',
  };

  // Layout grid style
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '58% 38%',
    gap: '4%',
    width: '100%',
  };

  // Form styles
  const formContainerStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '10px',
    padding: '40px',
  };

  const formGroupStyle = {
    marginBottom: '25px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '10px',
    fontSize: '16px',
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    borderRadius: '5px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    fontSize: '16px',
    boxSizing: 'border-box',
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: '150px',
    resize: 'vertical',
  };

  const buttonStyle = {
    display: 'inline-block',
    padding: '14px 30px',
    backgroundColor: '#1e50a2',
    color: 'white',
    borderRadius: '5px',
    border: 'none',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  };

  const successMessageStyle = {
    marginTop: '20px',
    padding: '12px',
    backgroundColor: '#4caf50',
    color: 'white',
    borderRadius: '5px',
    textAlign: 'center',
  };

  // Info section styles
  const infoContainerStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '10px',
    padding: '40px',
    height: '100%',
    boxSizing: 'border-box',
  };

  const infoItemStyle = {
    marginBottom: '30px',
  };

  const infoTitleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#4287f5',
  };

  const infoTextStyle = {
    fontSize: '16px',
    color: '#aab7d4',
    lineHeight: '1.6',
  };

  const socialIconsStyle = {
    display: 'flex',
    marginTop: '30px',
  };

  const socialIconStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
  };

  // Media query effect - applied with JavaScript
  const getResponsiveStyles = () => {
    if (window.innerWidth <= 768) {
      return {
        gridStyle: {
          gridTemplateColumns: '1fr',
          gap: '30px',
        },
        formContainerStyle: {
          marginBottom: '30px',
        }
      };
    }
    return {};
  };

  // Apply responsive styles
  const responsiveStyles = getResponsiveStyles();
  const finalGridStyle = { ...gridStyle, ...responsiveStyles.gridStyle };
  const finalFormContainerStyle = { ...formContainerStyle, ...responsiveStyles.formContainerStyle };

  return (
    <section id="contact">
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={headingStyle}>Contact Us</h2>
          <p style={subheadingStyle}>
            We're here to help and answer any question you might have.
          </p>
        </div>
        
        <div style={finalGridStyle}>
          {/* Contact Form */}
          <div style={finalFormContainerStyle}>
            <form onSubmit={handleSubmit}>
              <div style={formGroupStyle}>
                <label htmlFor="email" style={labelStyle}>Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Your email address"
                  style={inputStyle} 
                />
              </div>
              
              <div style={formGroupStyle}>
                <label htmlFor="message" style={labelStyle}>Message</label>
                <textarea 
                  id="message" 
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  placeholder="How can we help you?"
                  style={textareaStyle}
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                style={buttonStyle}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#2563EB';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 7px 14px rgba(0, 0, 0, 0.2)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#1e50a2';
                  e.target.style.transform = 'none';
                  e.target.style.boxShadow = 'none';
                }}
              >
                Send Message
              </button>
              
              {submitted && (
                <div style={successMessageStyle}>
                  Thanks for your message! We'll get back to you soon.
                </div>
              )}
            </form>
          </div>
          
          {/* Contact Info */}
          <div style={infoContainerStyle}>
            <div style={infoItemStyle}>
              <h3 style={infoTitleStyle}>Email Us</h3>
              <p style={infoTextStyle}>
                support@laki.com
              </p>
            </div>
            
            <div style={infoItemStyle}>
              <h3 style={infoTitleStyle}>Call Us</h3>
              <p style={infoTextStyle}>
                +1 (234) 567-8901
              </p>
            </div>
            
            <div style={infoItemStyle}>
              <h3 style={infoTitleStyle}>Visit Us</h3>
              <p style={infoTextStyle}>
                123 Investment Street<br />
                Financial District<br />
                Nairobi, Kenya
              </p>
            </div>
            
            <div style={socialIconsStyle}>
              <a href="#" style={socialIconStyle}>
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" style={socialIconStyle}>
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" style={socialIconStyle}>
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" style={socialIconStyle}>
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;